import extendNode from '../extendNode.mjs'
import useComponentNode from '../_COMPONENT/useComponentNode.jsx'
import meta from './metaIsrfreq.mjs'
import Model from './ModelIsrfreq.mjs'
import PropertiesPane from './PropertiesPaneIsrfreq.jsx'
import ReqType from './ReqType.jsx'

const reqTypes = new Map(
    ReqType.map(([type, name, icon]) => [type, {icon, name, type}])
)

export default () => {
    const ComponentNode = useComponentNode()

    return extendNode(ComponentNode, {
        ...meta,
        Model,
        PropertiesPane,

        getIcons(map, node) {
            const {reqType} = node.data
            const {icon} = reqTypes.get(reqType) ?? {}

            if (icon) {
                return [icon]
            }
            else {
                return []
            }
        },

        getTextPrefix(map, node) {
            let prefix = ''
            const {moduleType, reqType} = node.data

            if (reqType) {
                prefix += reqTypes.get(reqType).name
            }

            if (moduleType) {
                prefix += map.BizNode[moduleType].typeName(map)
            }

            if (prefix) {
                return prefix + ' |'
            }
            else {
                return ComponentNode.getTextPrefix.call(this, map, node)
            }
        },

        async _atOwnerPush(map, node, event) {
            const d = await this._getPushData(map, node)
            event.detail.isrfReqs.push(d)
        },

        _getCategories(map, node) {
            return [
                'ISRFREQ_BASMODULE',
                'ISRFREQ_TARMODULE',
                'ISRFREQ_INCDESC',
            ]
        },

        _getDefaultDataFields(map, node) {
            return {
                ...ComponentNode._getDefaultDataFields.call(this, map, node),
                reqType: 'UPT',
            }
        },

        _getShape(map, node) {
            return 'EllipseRectangle'
        },
    })
}
